import { decodeGooglePlayReferrer } from '@shared/utils/decode/referrerDecode';
import { LSK, SSK } from '@shared/utils/storage/config';
import { sessionAESStorage } from '../storage';
import { useUserTypeStore } from '@/mobile/store/UserType';
import { useUserCreate } from '@shared/stores/User';
import { TouristLoginStatus } from '@shared/stores/User/types';
import { Track } from '@/handler/event';
import { bizEvent } from '@utils/observer/eventManagers';

export const originalSetGooglePlayReferrer = async (googlePlayReferrer: string) => {
	const _googlePlayReferrer = googlePlayReferrer.replace(',', '&');
	const searchParams = new URLSearchParams(_googlePlayReferrer);
	const inviteParam = searchParams.get('share_info');
	sessionAESStorage.setItem(SSK.INVITE, inviteParam);

	localStorage.setItem(LSK.GOOGLE_PLAY_REFERRER, googlePlayReferrer);

	// 触发事件，通知 GOOGLE_PLAY_REFERRER 已更新
	bizEvent.emitGooglePlayReferrerChange({ referrer: googlePlayReferrer });

	if (localStorage.getItem(LSK.REFERRER_DECODE_RESULT)) return;
	const decodeResult = await decodeGooglePlayReferrer(googlePlayReferrer);
	localStorage.setItem(LSK.REFERRER_DECODE_RESULT, JSON.stringify(decodeResult));
	const initUserTypeWithReferrer = useUserTypeStore.getState().initUserTypeWithReferrer;
	initUserTypeWithReferrer(googlePlayReferrer);
};

export const originalSetDeviceId = (deviceId: string) => {
	localStorage.setItem(LSK.DEVICE_ID, deviceId);
};

export const originalSetDeviceIdFailed = (errorMessage: string) => {
	useUserCreate.setState({
		touristLoginStatus: TouristLoginStatus.DeviceIdError,
	});
	Track.action.device_id_failed({
		error_message: errorMessage,
	});
};
